import {ProductService} from "../resource";

const ProductModule = {
	namespaced: true,
	state: {
		datas: [],
		// Per-page product lists (owner 2026-10-07: /admin/product and
		// /admin/product_platform are both kept alive by the taskbar and used to
		// share `datas`, so whichever page loaded last showed its rows in BOTH
		// tabs). Each list page now reads its own slot via getDataFor(key) and
		// loads through listDataFor({ key, version, params }). `datas` stays for
		// the legacy consumers (order forms, reports, PO) that are not list pages.
		datasByKey: {},
		data_sku_random: [],
		currentPage : 1,
		platformCurrentParams : {
			status: 0,
			mappingStatus: 2,
			currentPage: 1,
		}
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		},
		SET_DATA_FOR(state, { key, data }) {
			state.datasByKey = Object.assign({}, state.datasByKey, { [key]: data });
		},
		SET_SKU_RANDOM(state, data) {
			state.data_sku_random = data;
		},
		SET_CURRENT_PAGE(state, data) {
			state.currentPage = data;
		},
		SET_PLATFORM_CURRENT_PARAMS(state, data) {
			state.platformCurrentParams = data;
		}
	},
	actions: {
		createData({ commit, state }, data) {
			return ProductService.ProductCreate(data);
		},

		updateData({ commit, state }, data) {
			return ProductService.ProductUpdate(data.id,data.payload);
		},

		// V3 — used by the product form so the App shopping-page fields
		// (app_*) and stock_sync_enabled survive the save. Other callers
		// (platform product views) stay on the V1 actions above.
		createDataV3({ commit, state }, data) {
			return ProductService.ProductCreateV3(data);
		},

		updateDataV3({ commit, state }, data) {
			return ProductService.ProductUpdateV3(data.id,data.payload);
		},
		updatePlatformData({ commit, state }, data) {
			return ProductService.ProductPlatformUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return ProductService.ProductDelete(data);
		},

		async listDataV1({ commit, state }, data) {
			try
			{
				const response = await ProductService.ProductListV1(data);
				commit("SET_DATA", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA", []);
			}
		},
		// Same endpoints as listDataV1 / listDataV3, but the rows land in a slot
		// named by the caller instead of the shared `datas`.
		async listDataFor({ commit }, { key, version, params }) {
			const call = version === "v3" ? ProductService.ProductListV3 : ProductService.ProductListV1;
			try {
				const response = await call.call(ProductService, params);
				const rows = response && response.data && response.data.Data != null ? response.data.Data : [];
				commit("SET_DATA_FOR", { key, data: rows });
				return rows;
			} catch (error) {
				console.log(error);
				commit("SET_DATA_FOR", { key, data: [] });
				return [];
			}
		},
		async listDataV3({ commit, state }, data) {
			try
			{
				const response = await ProductService.ProductListV3(data);
				commit("SET_DATA", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA", []);
			}
		},
		listSku({ commit, state }, data) {
				return ProductService.ProductSkuList(data);
		},
		
		getDetail({ commit, state }, data) {
				return ProductService.ProductDetail(data);
		},
		setCurrentPage({ commit, state }, data){
			commit("SET_CURRENT_PAGE",data)
		},
		setPlatformCurrentParams({ commit, state }, data){
			console.log(data)
			commit("SET_PLATFORM_CURRENT_PARAMS",data)
		},


		// Random
		async listSkuRandom({ commit, state }, data) {
			try
			{
				const response = await ProductService.SKURandomList(data);
				commit("SET_SKU_RANDOM", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_SKU_RANDOM", []);
			}
		},
		createSkuRandom({ commit, state }, data) {
			return ProductService.SKURandomCreate(data);
		},
		deleteSkuRandom({ commit, state }, data) {
			return ProductService.SKURandomDelete(data);
		},
		toggleStockSync({ commit, state }, data) {
			return ProductService.StockSyncToggle(data.id, data.payload);
		},
		syncProduct({ commit, state }, data) {
			return ProductService.SyncProduct(data);
		},
		calculateStock({ commit, state }, data) {
			return ProductService.CalculateStock(data);
		},
		packingOrders({ commit, state }, productID) {
			return ProductService.PackingOrders(productID);
		},
		packingOrdersList({ commit, state }, { productID, params }) {
			return ProductService.PackingOrdersList(productID, params);
		},
	},
	getters: {
		getData(state) {
			return state.datas;
		},
		getDataFor(state) {
			return key => state.datasByKey[key] || [];
		},
		getDataSkuRandom(state) {
			return state.data_sku_random;
		},
		getDataWithAll(state) {
			return  [
				{id:0,name:"--- สินค้าและโปรโมชั่น --- "},...state.datas ];
		},
		getCurrentPage(state) {
			return state.currentPage;
		},
		getPlatformCurrentParams(state) {
			return state.platformCurrentParams;
		}

	},
};

export default ProductModule;